<template>
  <div :class="[state == 22 ? 'changeBgc' : '']">
    <Header
      ref="headRef"
      @openVisible="openVisible"
      :position="
        state == 0 ||
        state == 8 ||
        state == 10 ||
        (!state && !token) ||
        (state == 3 && userInfo.reapply_time < new Date().getTime())
          ? true
          : false
      "
    />
    <!-- ------------------ Home Loan ------------------ -->
    <div
      class="bannerBox"
      v-if="
        state == 0 ||
          state == 8 ||
          state == 10 ||
          (!state && !token) ||
          (state == 3 && userInfo.reapply_time < new Date().getTime())
      "
    >
      <!-- loan box -->
      <div class="loanMainBox">
        <img class="bannerImg" src="../../assets/webImg/banner.png" alt="" />
        <div class="leftTitleBox">
          <h2>Rápido Seguridad Cantidad alta</h2>
          <p>¡Utiliza MasterSol para liberar tus fondos!</p>
        </div>
        <div class="rightMainLogin">
          <!-- loan mainContent -->
          <div class="loanDetail">
            <ul>
              <li>
                <p class="title">El monto solicitado de su préstamo</p>
                <el-select v-model="loanDay" placeholder="" @change="changeDay">
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </li>
              <li>
                <p class="title">Días de plazo préstamo</p>
                <span class="text"
                  >S/ {{ add_comma_toThousands(loanNum) }}</span
                >
              </li>
              <li>
                <el-slider
                  @change="onChange"
                  :show-tooltip="false"
                  v-model="loanNum"
                  :step="10"
                  :min="maxAmount == minAmount ? showMinAmount : minAmount"
                  :max="maxAmount"
                  :disabled="sliderDisabled"
                >
                </el-slider>
              </li>
              <li class="numSection">
                <p>S/ {{ maxAmount == minAmount ? maxAmount : minAmount }}</p>
                <p>S/ {{ add_comma_toThousands(maxAmount) }}</p>
              </li>
            </ul>
          </div>
          <!-- sub Btn -->
          <div class="subBtnBox" @click="submitLoan">
            <p>
              Solicitar ahora su préstamo
            </p>
            <img src="../../assets/webImg/rightIcon.png" alt="" />
          </div>
          <!-- calculate detail -->
          <div class="trialDetail" v-if="userInfo.is_reloan == 1">
            <h3>Detalles del préstamo</h3>
            <ul>
              <li>
                <p>Fecha de vencimiento</p>
                <p>{{ reLoanDate || moment(repaymentData, 1, 1) }}</p>
              </li>
              <li>
                <p>Monto de depósito</p>
                <p>S/ {{ add_comma_toThousands(loanNum) }}</p>
              </li>
              <li>
                <p>Monto de pago</p>
                <p>S/ {{ add_comma_toThousands(Math.ceil(totalRepayment)) }}</p>
              </li>
              <li @click="openDetil">
                <p>
                  Tasa de interés total
                </p>
                <van-icon
                  :style="{
                    transform: detailShow ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'all .2s',
                  }"
                  name="arrow-down"
                />
              </li>
              <li
                :style="{
                  height: detailShow ? '2.2rem' : '0',
                  overflow: 'hidden',
                  transition: 'all .2s',
                  marginBottom: 0,
                  background: '#F5F5F5',
                  borderRadius: '0.1rem',
                  display: 'block',
                }"
              >
                <ul class="childList">
                  <li>
                    <p>Interés</p>
                    <p>
                      S/ {{ add_comma_toThousands(Math.ceil(totalInterest)) }}
                    </p>
                  </li>
                  <li>
                    <p>Cargo de servicios</p>
                    <p>
                      S/ {{ add_comma_toThousands(Math.ceil(totalServiceFee)) }}
                    </p>
                  </li>
                  <li>
                    <p>IGV</p>
                    <p>S/ {{ add_comma_toThousands(Math.ceil(igv)) }}</p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- ------ detail end ------ -->
        </div>
      </div>
    </div>

    <!-- ------------------ User State ------------------ -->
    <UerState
      v-if="
        state == 4 ||
          state == 2 ||
          state == 20 ||
          state == 6 ||
          (state == 3 && new Date().getTime() < userInfo.reapply_time) ||
          state == 12 ||
          state == 5
      "
      ref="useStateRef"
      @getUserInformation="getUserInformation"
    />

    <!-- first Loan Page -->
    <FrloanHome
      v-if="state == 22"
      :userInfo="userInfo"
      @getUserInformation="getUserInformation"
    />

    <RepaymentPage
      v-if="state == 7 || state == 9 || state == 11"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      :orderState="state"
    />

    <!-- ------------------ Contact Or About ------------------ -->
    <ContactOrAbout />

    <LoginDialog
      :visible.sync="loginVisible"
      @getUserInformation="getUserInformation"
      @getCurrentNum="getCurrentNum"
      @closeDialog="closeVisible"
    />
  </div>
</template>

<script>
import {
  getInfor,
  orderConfirm,
  getProduct,
  createOrderForm,
  orderCalculate,
  getCurrentInfo,
} from "../../utils/api/h5page.js";
import Header from "../../components/webComponents/header.vue";
import ContactOrAbout from "../../components/webComponents/contactOrAbout.vue";
import LoginDialog from "../../components/webComponents/loginDialog.vue";
import UerState from "./userState.vue";
import FrloanHome from "./frloanHome.vue";
import RepaymentPage from "./repayment.vue";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
    LoginDialog,
    UerState,
    FrloanHome,
    RepaymentPage,
  },
  props: {},
  data() {
    return {
      userInfo: {},
      moment: this.$setMoment,
      state: null,
      token: "1",
      loading: null,
      repaymentData: "",
      reLoanDate: "",

      dayList: [
        { value: 7, label: "7 Días" },
        { value: 14, label: "14 Días" },
        { value: 30, label: "30 Días" },
        { value: 45, label: "45 Días" },
        { value: 90, label: "90 Días" },
        { value: 180, label: "180 Días" },
      ],
      loanNum: 8000, // 借款金额
      loanDay: 180, // 借款天数
      totalServiceFee: "", // 总服务费
      totalRepayment: "", // 总应还
      totalInterest: "", // 总利息
      totalInterestRate: "", // 总利率
      igv: "",
      minAmount: 100,
      maxAmount: 10000,
      showMinAmount: 100,
      detailShow: false,
      loginVisible: false,
      sliderDisabled: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
      this.getUserInformation();
    } else {
      this.token = "";
    }
    setTimeout(() => {
      client.record("login").then((r) => {
        console.log(r);
        localStorage.setItem("tokenKey", r);
      });
    }, 10);
  },
  methods: {
    onChange() {
      if (this.userInfo.is_reloan == 1) {
        this.calculateNum();
      }
    },

    // 获取用户订单信息
    getUserInformation() {
      this.openLoading();
      getInfor().then(({ data }) => {
        if (data.code == 0) {
          this.userInfo = data.data.loan_info;
          this.state = data.data.loan_info.order_status;
          localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          this.$store.commit("setUserInfo", this.userInfo);
          this.$refs.headRef.setToken();
          this.reloanDeal();
          setTimeout(() => {
            this.$refs.useStateRef.setUserData(data.data);
          }, 100);
        }
      });
    },

    // 复贷滑动金额更新临时订单 更新试算
    calculateNum() {
      const params = {
        loan: this.loanNum.toString(),
        period: this.loanDay.toString(),
        product_id: this.product_id.toString(),
        order_label: "FAST_RELOAN",
      };
      createOrderForm(params).then((res) => {
        if (res.data.code == 0) {
          // 试算接口
          orderCalculate({
            accountCouponId: "-1",
            borrowAmount: this.loanNum,
          }).then(({ data }) => {
            this.totalServiceFee = data.data.totalServiceFee;
            this.totalRepayment = data.data.totalRepayAmount;
            this.totalInterest = data.data.totalInterest;
            this.igv = data.data.totalGst;
            this.reLoanDate = data.data.firstRepayDateFormat;
            this.closeLoading();
          });
        }
        this.closeLoading();
      });
    },

    // 处理复贷逻辑
    async reloanDeal() {
      // 获取产品列表
      getProduct().then(({ data }) => {
        if (data.code == 0) {
          sessionStorage.setItem(
            "jsonData",
            JSON.stringify({
              loanNum: data.data.product_suitable[0].max_amount,
              loanDay: data.data.product_suitable[0].min_period,
            })
          );
          // 复贷时 调取试算接口
          if (
            this.userInfo.is_reloan == 1 &&
            (this.state == 0 ||
              this.state == 8 ||
              this.state == 10 ||
              (!this.state && !this.token) ||
              (this.state == 3 &&
                this.userInfo.reapply_time < new Date().getTime()))
          ) {
            this.setProductDetail(data.data.product_suitable[0]);
            this.dayList = data.data.product_suitable.map((item) => {
              return {
                label: item.min_period + " Días",
                value: item.min_period,
                ...item,
              };
            });
          } else {
            this.closeLoading();
          }
        }
      });
    },

    // 配置产品详情
    setProductDetail(row) {
      this.loanNum = row.max_amount;
      this.loanDay = row.max_period;
      this.minAmount = row.min_amount;
      this.maxAmount = row.max_amount;
      this.product_id = row.id;
      if (row.min_amount == row.max_amount) {
        this.sliderDisabled = true;
        this.showMinAmount = this.minAmount - 1;
      } else {
        this.sliderDisabled = false;
      }

      setTimeout(() => {
        this.calculateNum();
      }, 10);
    },
    // loan button
    async submitLoan() {
      if (!localStorage.getItem("token")) {
        return (this.loginVisible = true);
      }

      const res = await getCurrentInfo();
      this.currentStep = res.data.data.current_step;

      sessionStorage.setItem(
        "jsonData",
        JSON.stringify({
          loanNum: this.loanNum,
          loanDay: this.loanDay,
        })
      );

      if (res.data.data.current_step == 1006) {
        this.$Toast(
          "Su selfie ha caducado, por favor complete selfie antes de prestar un nuevo préstamo"
        );
        this.$router.push("/faceIdentifyWeb");
        return;
      }

      if (
        res.data.data.current_step !== 1006 &&
        res.data.data.current_step !== 1110 &&
        res.data.data.current_step !== 105
      ) {
        this.$router.push("/registerInfoWeb");
        return;
      }

      // 首贷用户
      if (this.userInfo.is_reloan == 0) {
        const params = {
          loan: this.loanNum.toString(),
          period: this.loanDay.toString(),
          is_new: 1,
          coupon_id: "",
          order_label: "FAST_RELOAN",
          token_key: localStorage.getItem("tokenKey"),
        };

        if (res.data.data.current_step == 1110) {
          this.openLoading();
          orderConfirm(params).then(({ data }) => {
            if (data.code == 0) {
              this.getUserInformation();
            }
          });
        }
      }
      // 复贷用户
      else if (
        this.userInfo.is_reloan == 1 &&
        res.data.data.current_step == 105
      ) {
        const params = {
          loan: this.loanNum,
          period: this.loanDay,
          is_new: 2,
          coupon_id: -1,
          order_label: "FAST_RELOAN",
          token_key: localStorage.getItem("tokenKey"),
        };
        if (!localStorage.getItem("tokenKey")) {
          this.loading = false;
          return Dialog.alert({
            message:
              "Este navegador no es compatible con los servicios relacionados con MasterSol, por lo que no podemos recibir su solicitud. Por favor, cambie de navegador y continúe enviando.",
            theme: "round-button",
            confirmButtonText: "copy",
          }).then(() => {
            // on close
            if (window.location.host == "www.mastersol.tech") {
              navigator.clipboard.writeText("https://www.mastersol.tech/");
            } else {
              navigator.clipboard.writeText(
                "https://mastersol.jinglewill.com/211345390/#/"
              );
            }
          });
        }
        this.openLoading();
        orderConfirm(params).then(({ data }) => {
          if (data.code == 0) {
            this.getUserInformation();
          }
        });
      }
    },

    closeVisible() {
      this.loginVisible = false;
    },

    openVisible() {
      this.loginVisible = true;
    },

    openLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    closeLoading() {
      this.loading.close();
    },

    // catch loan detail
    openDetil() {
      this.detailShow = !this.detailShow;
    },

    // 获取当前填写状态
    getCurrentNum() {
      getCurrentInfo().then(({ data }) => {
        this.currentStep = data.data.current_step;
      });
    },

    // detail amount show
    add_comma_toThousands(num) {
      var nums = (num || 0).toString();
      var result = "";
      while (nums.length > 3) {
        result = "," + nums.slice(-3) + result;
        nums = nums.slice(0, nums.length - 3);
      }
      if (nums) {
        result = nums + result;
      }
      return result;
    },

    changeDay(row) {
      if (this.userInfo.is_reloan == 0 || !this.token) return;
      this.dayList.map((item) => {
        if (item.value == row) {
          this.setProductDetail(item);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.changeBgc {
  background-color: #f5f5f5;
}
.bigBox {
  width: 100%;
}
.bannerBox {
  width: 100%;
  background: linear-gradient(180deg, #ffeeea 0%, #ffffff 100%);
}
.loanMainBox {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 1.3rem;
  width: 100%;
  min-height: 7.58rem;

  .bannerImg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 7.58rem;
  }
  .leftTitleBox {
    position: relative;
    z-index: 5;
    width: 4.73rem;
    margin-right: 0.5rem;
    margin-top: 0.66rem;
    h2 {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.7rem;
      color: #333333;
      margin-bottom: 0.5rem;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.34rem;
      color: #333333;
    }
  }
  .rightMainLogin {
    position: relative;
    z-index: 5;
    padding: 0.44rem 0.4rem 0;
    width: 6.8rem;
    min-height: 5.19rem;
    background: #ffffff;
    box-shadow: 0.06rem 0.06rem 0px 0px #333333;
    border-radius: 0.4rem;
    border: 0.03rem solid #333333;
    .loanDetail {
      width: 6rem;
      height: 2.9rem;
      padding: 0.38rem 0.29rem 0.37rem;
      background: #fff2ed;
      border-radius: 0.2rem;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
      }
      ul {
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.27rem;
          /deep/ .el-select {
            width: 1.7rem;
            height: 0.56rem;
          }
          /deep/ .el-input__inner {
            border: 0.01rem solid #333333;
            border-radius: 0.12rem;
            font-family: Roboto, Roboto;
            font-weight: 700;
            font-size: 0.25rem;
            color: #333333;
            padding: 0 0.2rem 0 0.16rem;
            background: #fff2ed;
          }
          /deep/ .el-input__suffix {
            right: 0.05rem;
          }
          .text {
            font-family: Roboto, Roboto;
            font-weight: 700;
            font-size: 0.25rem;
            color: #333333;
          }
          /deep/ .el-slider {
            width: 100%;
          }
          /deep/ .el-slider__button-wrapper {
            width: 0.4rem;
            height: 0.4rem;
          }
          /deep/ .el-slider__button {
            display: block;
            width: 100%;
            height: 100%;
            background: #ffffff;
            border: 0.08rem solid #c90000;
          }
          /deep/ .el-slider__runway {
            height: 0.14rem;
            background: #fffaf8;
            border-radius: 0.07rem;
          }
          /deep/ .el-slider__bar {
            background: #c90000;
            border-radius: 0.09rem;
            height: 100%;
          }
          /deep/ .el-slider__stop {
            display: none;
          }
          /deep/ .el-slider__button-wrapper {
            top: -0.15rem;
          }
        }
        .numSection {
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.16rem;
            color: #666666;
            line-height: 0.19rem;
            margin-top: -0.32rem;
          }
        }
      }
    }
    .subBtnBox {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 5rem;
      height: 0.8rem;
      background: #c90000;
      box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
      border-radius: 0.4rem;
      margin: 0.32rem auto 0;
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.24rem;
        color: #ffffff;
      }
      img {
        display: block;
        margin-left: 0.12rem;
        width: 0.4rem;
      }
    }
    .trialDetail {
      width: 100%;
      background: #ffffff;
      border-radius: 0.2rem;
      padding: 0.34rem 0.24rem;
      margin: 0.3rem 0 0.17rem;
      h3 {
        font-family: Roboto, Roboto;
        font-weight: 700;
        font-size: 0.32rem;
        color: #333333;
        margin-bottom: 0.4rem;
      }
      ul {
        li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.3rem;
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.26rem;
            color: #333333;
          }
          .van-icon-arrow-down {
            font-size: 0.32rem;
          }
          .childList {
            padding: 0.31rem 0.24rem;
            li {
              p {
                font-family: Roboto, Roboto;
                font-weight: 400;
                font-size: 0.24rem;
                color: #666666;
              }
              &:last-child {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
.el-loading-text {
  font-size: 0.26rem !important;
}
.el-icon-loading {
  font-size: 0.66rem;
}
</style>
